export default "__VITE_ASSET__XVWTNlgw__"